import React from 'react';
import './TextCheckNotice.css';

// Shown above the compose box when the text checker can't tell what the recruiter meant. The text
// is NOT sent; the recruiter edits it, or sends it exactly as typed.
export default function TextCheckNotice({ question, onSendAsWritten, sending }) {
  if (!question) return null;
  return (
    <div className="tcn" role="alert">
      <div className="tcn-text"><strong>Please clarify before sending:</strong> {question}</div>
      <div className="tcn-actions">
        <span className="tcn-hint">Edit your text, or</span>
        <button type="button" className="tcn-btn" onClick={onSendAsWritten} disabled={sending}>Send as written</button>
      </div>
    </div>
  );
}
